"use client";

import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/next";

export default function Observability() {
  const speedInsightsEndpoint = "/_templates/_vercel/speed-insights";
  const analyticsEndpoint = "/_templates/_vercel/insights";

  return (
    <>
      {/**
       * Following this documentation: https://coda.io/d/Team-Bloom_ddahI04D0nH/Vercel-Analytics-SpeedInsights-403-bug_suuK3Uuu#_lu3kLAwJ
       *
       * There are a couple issues with Vercel's analytics to manage:
       *
       * 1) The `endpoint` prop allows us to configure these modules to
       *    use different base URLs. For example, when we deploy to
       *    `zapier.com`, these modules will default to making requests
       *    to `zapier.com/_vercel/*`, but we deploy _many_ apps to
       *    zapier.com so there's a high risk of collisions and other
       *    unexpected behaviour. _With_ the `endpoint` prop, we can
       *    guarantee these modules make requests to our own app even
       *    if the requests originate from zapier.com.
       *
       * 2) Currently, our preview environments are accessible through
       *    `zapier-staging.com`. This allows us to test a logged-in
       *    state from non-production environment, but makes it
       *    challenging to set an endpoint because previews have
       *    dynamic URLs. For example, a preview environment's URL
       *    might be templates-fxa0wgyr6.vercel.zapier-deployment.com.
       *
       * To simplify the problem, for now we allow the presence of
       * `process.env.NEXT_PUBLIC_ANALYTICS_ENDPOINT` to be the source
       * of truth. This allows us to configure it for use in production
       * but leave a relative path in preview and staging environments.
       *
       * In the future, we may be able to use the Vercel CLI to get the
       * dynamic URL when we do a staging build.
       */}
      <Analytics
        scriptSrc={`${analyticsEndpoint}/script.js`}
        endpoint={analyticsEndpoint}
      />
      <SpeedInsights
        scriptSrc={`${speedInsightsEndpoint}/script.js`}
        endpoint={`${speedInsightsEndpoint}/vitals`}
      />
    </>
  );
}
